import CpoGuide from '@di-shared/features/diag/cpo/DiagCpoGuide';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import Header from '@di-shared/features/common/Header';
import React from 'react';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

function CpoGuidePage() {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T20250')}</h1>
      </Header>
      <main
        id="content"
        className="content page_car_management"
      >
        <CpoGuide />
      </main>
    </div>
  );
}

export default CpoGuidePage;
